/**
 * CURSORI NUMERICI EIDOS (Gioiello Sagoma, 12 ott 2026): i tre cursori "Zoom sagoma", "Sposta X", "Sposta Y" sono
 * NASCOSTI nel fork, perche' la foto si sposta e si ingrandisce con le dita nel pannello foto (EidosFotoComponent),
 * che li aggiorna da solo. Tutti gli altri cursori restano quelli standard di ShapeDiver.
 */
import ParameterSliderComponent from "@AppBuilderLib/entities/parameter/ui/ParameterSliderComponent";
import {useParameterComponentCommons} from "@AppBuilderLib/entities/parameter/model/useParameterComponentCommons";
import {
	PropsParameterComponent,
	PropsParameterWrapper,
} from "@AppBuilderLib/entities/parameter/config/propsParameter";

// (13 ott 2026) anche "Soglia": la foto arriva gia' come stencil bianco e nero (stencilFoto.ts), il cliente non deve regolare nulla
const NASCOSTI = ["Zoom sagoma", "Sposta X", "Sposta Y", "Soglia"];

export default function EidosNumeroComponent(
	props: PropsParameterComponent & Partial<PropsParameterWrapper>,
) {
	const {definition} = useParameterComponentCommons<number>(props, 0);
	const nomi = [definition?.name, definition?.displayname].filter(Boolean) as string[];
	if (nomi.some((n) => NASCOSTI.includes(n))) return <></>;
	return <ParameterSliderComponent {...props} />;
}
